import type { NavItem } from "@/types/global";

export const mainNavigation: NavItem[] = [
  { label: "Domů", href: "/" },
  {
    label: "Účetnictví",
    href: "/ucetnictvi",
    description: "Vedení účetnictví a daňové evidence, daňová přiznání",
  },
  {
    label: "Daňové poradenství",
    href: "/danove-poradenstvi",
    description: "Daňové konzultace, optimalizace a zastupování",
  },
  {
    label: "Mzdy",
    href: "/zpracovani-mezd",
    description: "Zpracování mezd a personální agenda",
  },
  {
    label: "O firmě",
    href: "/o-firme",
    description: "Historie, tým a odborné zázemí",
  },
  {
    label: "Poradna",
    href: "/poradna",
    description: "Odpovědi na časté otázky",
  },
  {
    label: "Dokumenty",
    href: "/dokumenty",
    description: "Formuláře a dokumenty ke stažení",
  },
];

export const footerNavigation = {
  services: [
    { label: "Účetnictví", href: "/ucetnictvi" },
    { label: "Daňové poradenství", href: "/danove-poradenstvi" },
    { label: "Zpracování mezd", href: "/zpracovani-mezd" },
  ] satisfies NavItem[],
  company: [
    { label: "O firmě a tým", href: "/o-firme" },
    { label: "Poradna a FAQ", href: "/poradna" },
    { label: "Dokumenty ke stažení", href: "/dokumenty" },
    { label: "Kontakt", href: "/kontakt" },
  ] satisfies NavItem[],
  legal: [
    { label: "Ochrana osobních údajů", href: "/ochrana-osobnich-udaju" },
    { label: "Cookies", href: "/ochrana-osobnich-udaju#cookies" },
  ] satisfies NavItem[],
};

export const primaryCta = {
  label: "Domluvit konzultaci",
  href: "/kontakt",
} as const;

export const secondaryCta = {
  label: "Prohlédnout služby",
  href: "/#sluzby",
} as const;
